import { render, staticRenderFns } from "./ModalHistorico.vue?vue&type=template&id=4db4cca8&"
import script from "./ModalHistorico.vue?vue&type=script&lang=js&"
export * from "./ModalHistorico.vue?vue&type=script&lang=js&"
import style0 from "./ModalHistorico.vue?vue&type=style&index=0&id=4db4cca8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports